import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { setSort } from '../slices/filtersSlice';
const Sort = React.memo(({ name }) => {
    const sortRef = React.useRef(null);
    const [isVisible, setIsVisible] = React.useState(false);
    const dispatch = useDispatch();
    const list = [
        { name: 'популярности (вверх)', type: 'rating&order=desc' },
        { name: 'популярности (вниз)', type: 'rating&order=asc' },
        { name: 'цене (самые дорогие)', type: 'price&order=desc' },
        { name: 'цене (самые дешевые)', type: 'price&order=asc' },
        { name: 'алфавиту (А-Я)', type: 'title&order=asc' },
        { name: 'алфавиту (Я-А)', type: 'title&order=desc' },
    ];
    const pickSort = (obj) => {
        dispatch(setSort(obj));
        setIsVisible(false);
    };
    React.useEffect(() => {
        const handleClickOutside = (e) => {
            const _e = e;
            if (sortRef.current && !_e.composedPath().includes(sortRef.current)) {
                setIsVisible(false);
            }
        };
        document.body.addEventListener('click', handleClickOutside);
        return () => document.body.removeEventListener('click', handleClickOutside);
    }, []);
    return (_jsxs("div", Object.assign({ ref: sortRef, className: "sort" }, { children: [_jsxs("div", Object.assign({ className: "sort__label" }, { children: [_jsx("svg", Object.assign({ width: "10", height: "6", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z", fill: "#2C2C2C" }) })), _jsx("b", { children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E:" }), _jsx("span", Object.assign({ onClick: () => setIsVisible(!isVisible) }, { children: name }))] })), isVisible && (_jsx("div", Object.assign({ className: "sort__popup" }, { children: _jsx("ul", { children: list.map((item, i) => _jsx("li", Object.assign({ className: name === item.name ? 'active' : '', onClick: () => pickSort(item) }, { children: item.name }), i)) }) })))] })));
});
export default Sort;
